<script setup lang="ts">
import { computed, ref } from "vue";

import ColorBadge from "@/components/ui/ColorBadge.vue";
import CopyableElement from "@/components/ui/CopyableElement.vue";
import SimpleButton from "@/components/ui/SimpleButton.vue";

const { apiKey } = defineProps<{
  apiKey: string;
}>();

const isKeyRevealed = ref(false);

const visibleApiKey = computed(() => {
  return isKeyRevealed.value ? apiKey : Array(apiKey.length).fill("*").join("");
});
</script>

<template>
  <div class="api-key-copy-modal-body">
    <ColorBadge color="red" left-icon="icon-warning">
      Please make sure the key is saved on a secure storage. For security purposes, the key can only
      be displayed once.
    </ColorBadge>

    <CopyableElement :text-to-copy="apiKey">
      <code class="key">{{ visibleApiKey }}</code>
      <SimpleButton
        :icon-left="isKeyRevealed ? 'icon-eye-slash' : 'icon-eye'"
        kind="ghost"
        @click="isKeyRevealed = !isKeyRevealed"
      />
    </CopyableElement>
  </div>
</template>

<style scoped>
.api-key-copy-modal-body {
  display: flex;
  flex-direction: column;
  gap: var(--numbers-16);

  .copyable-element {
    padding: var(--numbers-16);
  }

  .key {
    word-break: break-all;
  }

  .skore-button {
    height: auto;
    padding: 0;
    border: none;
    margin: 0;
    line-height: inherit;
    vertical-align: text-bottom;
  }
}
</style>
